import { useEffect, useState } from "react";

const InstallBanner = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallBanner, setShowInstallBanner] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault(); // Prevent auto prompt
      setDeferredPrompt(e); // Save the event
      setShowInstallBanner(true); // Show your banner
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstallClick = () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    deferredPrompt.userChoice.then(() => {
      setDeferredPrompt(null);
      setShowInstallBanner(false);
    });
  };

  if (!showInstallBanner) return null;

  return (
    <div style={styles.banner}>
      <span>Install CBX Suite on this computer for quicker access.</span>
      <button onClick={handleInstallClick} style={styles.button}>
        Install
      </button>
      <button
        onClick={() => setShowInstallBanner(false)}
        style={styles.dismiss}
        aria-label="Not now"
      >
        Not now
      </button>
    </div>
  );
};

const styles = {
  banner: {
    position: "fixed",
    bottom: 20,
    left: 20,
    display: "flex",
    alignItems: "center",
    gap: 10,
    backgroundColor: "#0b1f3a",
    color: "#fff",
    fontSize: 14,
    padding: "10px 20px",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
    zIndex: 1000,
  },
  button: {
    padding: "6px 12px",
    backgroundColor: "#ffffff",
    color: "#0b1f3a",
    fontWeight: 600,
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  dismiss: {
    padding: "6px 8px",
    background: "none",
    color: "#b8c4d6",
    border: "none",
    cursor: "pointer",
  },
};

export default InstallBanner;
